import axios from 'axios';
import getCookie from '../content/MyAccount/Services/Cookies';

export const getSubscriptions = async () => {
    const nowSessionId = getCookie() || undefined;

    const response = await axios.post("https://account.now.com/MyAccount/api/rb/getsubscriptions", {
      secureCookie: nowSessionId,
      callerReferenceNo: new Date().getTime().toString()
    }, {
      headers: {
        'Content-Type': 'text/plain'
      }
    });
    console.log('getSubscriptions', response.data);
    return response.data;
};